import { render, staticRenderFns } from "./PermissionManager.vue?vue&type=template&id=38458c62&"
import script from "./PermissionManager.vue?vue&type=script&lang=js&"
export * from "./PermissionManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports